export default "__VITE_ASSET__ba475782__"